module.exports = __webpack_public_path__ + "11_hair_brown.5d9539a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/11_hair_brown.png
// module id = 2QEl
// module chunks = 0